/* Quick add from product cards.
   - Single-variant products add straight to cart via the Cart AJAX API.
   - Multi-variant products send the shopper to the product page (furniture needs a choice).
   - Uses optimistic button states, then refreshes the cart drawer via the Section Rendering API
     so the free-shipping bar and item count update without a page reload. */
(function () {
  const SELECTOR = '[data-sg-quick-add]';

  function setState(btn, state, label) {
    btn.dataset.state = state;
    btn.textContent = label;
  }

  async function refreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    try {
      const res = await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`);
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('cart-drawer');
      if (!fresh) return;

      const innerSelectors = ['.drawer__inner', '.cart-drawer__form', '.drawer__footer'];
      innerSelectors.forEach((sel) => {
        const from = fresh.querySelector(sel);
        const to = drawer.querySelector(sel);
        if (from && to) to.innerHTML = from.innerHTML;
      });

      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.classList.add('active');
    } catch (e) {
      /* fall back to a normal cart visit */
      window.location.href = window.Shopify.routes.root + 'cart';
    }
  }

  function updateBubble(count) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach((el) => {
      el.textContent = count;
    });
    const icon = document.querySelector('.header__icon--cart');
    if (icon && !icon.querySelector('.cart-count-bubble') && count > 0) {
      const b = document.createElement('div');
      b.className = 'cart-count-bubble';
      b.innerHTML = `<span aria-hidden="true">${count}</span>`;
      icon.appendChild(b);
    }
  }

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest(SELECTOR);
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const id = btn.dataset.variantId;
    if (!id) return;

    const original = btn.textContent;
    setState(btn, 'loading', 'Adding…');

    try {
      const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add failed');

      setState(btn, 'done', 'Added');

      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
      updateBubble(cart.item_count);
      await refreshCartDrawer();

      setTimeout(() => setState(btn, 'idle', original), 1600);
    } catch (e) {
      setState(btn, 'error', 'Try again');
      setTimeout(() => setState(btn, 'idle', original), 1800);
    }
  });
})();
